var _excluded = ["id", "disabled", "status", "label", "placeholder", "contentLeft", "contentRight", "caption", "helperText", "style", "className", "size", "view", "onChange", "onKeyUp"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { FieldHelper } from '@salutejs/plasma-core';
import { TextFieldView } from '../../types';
import { Placeholder } from './Placeholder';
import { Input } from './Input';
import { Field, FieldWrapper } from './Field';
import { Content } from './Content';
import { Caption } from './Caption';
import { textFieldProps } from './TextField.props'; // eslint-disable-next-line prefer-arrow-callback

export var TextFieldB2C = /*#__PURE__*/forwardRef(function TextField(_ref, ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      status = _ref.status,
      label = _ref.label,
      placeholderInput = _ref.placeholder,
      contentLeft = _ref.contentLeft,
      contentRight = _ref.contentRight,
      caption = _ref.caption,
      helperText = _ref.helperText,
      style = _ref.style,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      view = _ref.view,
      onChange = _ref.onChange,
      onKeyUp = _ref.onKeyUp,
      rest = _objectWithoutProperties(_ref, _excluded);

  var placeholder = label || placeholderInput;
  var hasTextFieldDefaultView = view === TextFieldView["default"];
  var withCaption = !view || hasTextFieldDefaultView;
  var withoutCaption = !caption && !hasTextFieldDefaultView;
  var captionOrPlaceholder = !withCaption ? caption : placeholder;
  var currentId = id ? "".concat(id, "-label") : undefined;
  var ariaDescribedBy = id ? "".concat(id, "-helpertext") : undefined;
  return /*#__PURE__*/React.createElement(Field, {
    $disabled: disabled,
    $isContentLeft: Boolean(contentLeft),
    $isContentRight: Boolean(contentRight),
    $isHelper: Boolean(helperText),
    withDefaultPadding: withCaption || withoutCaption,
    properties: textFieldProps[size],
    contentLeft: contentLeft,
    status: status,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Caption, {
    visible: withCaption,
    id: currentId,
    caption: caption
  }), /*#__PURE__*/React.createElement(FieldWrapper, {
    status: status
  }, contentLeft && /*#__PURE__*/React.createElement(Content, {
    pos: "left"
  }, contentLeft), /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref,
    id: id,
    placeholder: placeholder,
    disabled: disabled,
    status: status,
    "aria-labelledby": currentId,
    "aria-describedby": ariaDescribedBy,
    onChange: onChange,
    onKeyUp: onKeyUp
  }, rest)), captionOrPlaceholder && /*#__PURE__*/React.createElement(Placeholder, {
    withCaption: withCaption,
    visible: size !== 'xs',
    htmlFor: id
  }, captionOrPlaceholder), contentRight && /*#__PURE__*/React.createElement(Content, {
    pos: "right"
  }, contentRight)), helperText && /*#__PURE__*/React.createElement(FieldHelper, {
    id: ariaDescribedBy
  }, helperText));
});